import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from '../../shared/DeleteButton.js';
import './TeamCardList.css';

const TeamCard = ({ row, onDeleted, ranches }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const langLabel = row.lang === 'pt-BR' ? 'PT' : 'EN';
  const role = row.role || 'messenger';
  const ranchName = ranches?.find(r => String(r._id) === String(row.ranch_id))?.name || '—';

  return (
    <div className={`team-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="team-card-main">
        <div className="team-card-name">{row.name || '—'}</div>
        <div className="team-card-lang">{langLabel}</div>
        <div className="team-card-phone">{row.phone_number || row.email || '—'}</div>
        <div className="team-card-role">{t(role)}</div>
        <div className="team-card-chevron">{expanded ? '▲' : '▼'}</div>
      </div>

      {expanded && (
        <div className="team-card-detail" onClick={e => e.stopPropagation()}>
          <div className="team-card-detail-row">
            <span>{t('name')}</span><span>{row.name || '—'}</span>
          </div>
          <div className="team-card-detail-row">
            <span>{t('email')}</span><span>{row.email || '—'}</span>
          </div>
          <div className="team-card-detail-row">
            <span>{t('phone_number')}</span><span>{row.phone_number || '—'}</span>
          </div>
          <div className="team-card-detail-row">
            <span>{t('language')}</span><span>{row.lang === 'pt-BR' ? 'Portuguese' : 'English'}</span>
          </div>
          <div className="team-card-detail-row">
            <span>{t('ranch')}</span><span>{ranchName}</span>
          </div>
          <div className="team-card-actions">
            <DeleteButton
              collection="teams"
              data={[row]}
              onComplete={onDeleted}
              onError={() => {}}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const TeamCardList = ({ data, onRefresh, ranches }) => {
  return (
    <div className="team-card-list">
      {data && data.map(row => (
        <TeamCard key={row._id} row={row} onDeleted={onRefresh} ranches={ranches} />
      ))}
      {(!data || data.length === 0) && (
        <div className="team-card-empty">—</div>
      )}
    </div>
  );
};

export default TeamCardList;
